export default {
  Container: {},
  HeaderTitle: {
    fontFamily: 'AvenirNext-Medium',
    fontSize: '30px',
    lineHeight: '1.3em',
    color: '#4a4a4a',
    marginBottom: '20px',
    textAlign: 'left',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  GroupPanel: {
    marginBottom: '5px',
    textAlign: 'left',
  },
  Title: {
    fontFamily: 'AvenirNext-DemiBold',
    fontSize: '14px',
    color: '#96979a',
    marginBottom: '15px',
    textAlign: 'left',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  GroupTitle: {
    fontSize: '10px',
    fontFamily: 'AvenirNext-Medium',
    color: '#848484',
    letterSpacing: '0.3px',
    paddingLeft: '15px',
    paddingRight: '15px',
    marginBottom: '10px',
    textAlign: 'left',
  },
  GroupField: {
    marginBottom: '20px',
    textAlign: 'left',
  },
  Field: {
    marginBottom: '15px',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  labelHours: {
    fontSize: '10px',
    color: '#96979a',
    fontFamily: 'AvenirNext-DemiBold',
  },
  FieldButton: {
    marginBottom: '0px',
  },
  buttonControl: {
    minWidth: '150px',
  },
  listError: {
    padding: '10px 10px 10px 25px',
    borderRadius: '5px',
    border: '1px solid red',
    margin: '0 15px 15px',
    color: 'red',
  },
  errorText: {},
};
